import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Copyright from './Copyright';
import SideMenu from './SideMenu';

function Layout() {
    const [collapsed, setCollapsed] = useState(false)
    const [resMenuToggle, setResMenuToggle] = useState(false);
    return (
        <>
            <main className="h-screen flex flex-col overflow-hidden">
                <Header collapsed={collapsed} setCollapsed={setCollapsed} resMenuToggle={resMenuToggle} setResMenuToggle={setResMenuToggle} />
                <div className="flex flex-1 min-h-0 flex-row flex-nowrap overflow-hidden">
                    <SideMenu collapsed={collapsed} setCollapsed={setCollapsed} resMenuToggle={resMenuToggle} setResMenuToggle={setResMenuToggle} />
                    <div className={`ps-4 bg-[#f0f2f5] p-4 relative z-20 transition-all duration-300 w-full ${collapsed ? 'xl:w-[95%]' : 'xl:w-[82%]'} flex min-h-0 flex-col overflow-hidden`}>
                        <div className="flex-1 min-h-0 overflow-y-auto">
                            <Outlet />
                        </div>
                    </div>
                </div>
                <Copyright />
            </main>
        </>
    );
}

export default Layout;
